export const navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};

export const views = {
  MONTH: 'month',
  WEEK: 'week',
  WORK_WEEK: 'work_week',
  DAY: 'day',
  AGENDA: 'agenda',
  ROSTER: 'roster'
};

export const reports = {
  SUMMARY: 'summary',
  WEEKLY: 'weekly',
  DAILY: 'daily',
  LEAVE: 'leave',
}
